import React, { useEffect } from 'react';
import StandAloneCommsCheck from '../StandAloneCommsCheck/StandAloneCommsCheck';
import Chat, { S1_FULL_SITE_DECOMMISSION, TCSO, TCSO_DUAL_FUEL } from '../chat/Chat';
import DecommissionAMeter from '../decommission/DecommissionAMeter';
import { ChatReasonContext, HomePageContext, homePageInitialState, HomePageState } from '../../context/HomePageContext';
import { DecommissionInputs, DecommissionInputsContext, decommissionInputsInitialState } from '../../context/DecommissionContext';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { getParamsFromURL } from '../util';
import DecommissionASite from '../decommission/s1-site/DecommissionASite';
import {
  DecommissionASiteInputs,
  DecommissionASiteInputsContext,
  DecommissionASiteInputsInitialState,
} from '../../context/DecommissionASiteContext';
import { CommsCheckInputs, CommsCheckInputsContext, commsCheckInputsInitialState } from '../../context/CommsCheckContext';
import { TcsoContext, tcsoInitialState, TcsoInputs } from '../../context/TcsoScreenContext';
import TcsoScreenManager from '../tcso/TcsoScreenManager';
import TcsoDualFuelScreenManager from '../tcso/TcsoDualFuelScreenManager';

export default function HomePage() {
  const [homePageState, setHomePageState] = React.useState<HomePageState>(homePageInitialState);
  const [decommissionASiteInputs, setDecommissionASiteInputs] = React.useState<DecommissionASiteInputs>(
    DecommissionASiteInputsInitialState,
  );
  const [reason, setReason] = React.useState<string>('');
  const params = getParamsFromURL();
  const [commsCheckInputs, setCommsCheckInputs] = React.useState<CommsCheckInputs>(commsCheckInputsInitialState);
  const [decommissionInputs, setDecommissionInputs] = React.useState<DecommissionInputs>(decommissionInputsInitialState);
  const [tcsoInputs, setTcsoInputs] = React.useState<TcsoInputs>(tcsoInitialState);
  const { enableDecommissioning } = useFlags();
  const { enableSOneSiteDecommission } = useFlags();
  const { enableAutomatedTcsoElecOnly } = useFlags();
  const { enableAutomatedTcsoDualFuel } = useFlags();

  useEffect(
    () =>
      setCommsCheckInputs({
        ...commsCheckInputs,
        mpxn: params.mpxn ?? '',
        msn: params.msn ?? '',
      }),
    [],
  );

  return (
    <HomePageContext.Provider value={{ homePageState, setHomePageState }}>
      <ChatReasonContext.Provider value={{ chatReason: reason, setChatReason: setReason }}>
        {!homePageState.automationInProgress && <Chat />}

        <CommsCheckInputsContext.Provider value={{ commsCheckInputs, setCommsCheckInputs }}>
          {reason === 'Engineer comms checker' && <StandAloneCommsCheck />}
        </CommsCheckInputsContext.Provider>

        <DecommissionInputsContext.Provider value={{ decommissionInputs, setDecommissionInputs }}>
          {enableDecommissioning && reason === 'Decommission a Meter' && <DecommissionAMeter />}
        </DecommissionInputsContext.Provider>

        <DecommissionASiteInputsContext.Provider value={{ decommissionASiteInputs, setDecommissionASiteInputs }}>
          {enableSOneSiteDecommission && reason === S1_FULL_SITE_DECOMMISSION && <DecommissionASite />}
        </DecommissionASiteInputsContext.Provider>

        <TcsoContext.Provider value={{ tcsoInputs, setTcsoInputs }}>
          {enableAutomatedTcsoElecOnly && reason === TCSO && <TcsoScreenManager />}
        </TcsoContext.Provider>

        {enableAutomatedTcsoDualFuel && reason === TCSO_DUAL_FUEL && <TcsoDualFuelScreenManager />}
      </ChatReasonContext.Provider>
    </HomePageContext.Provider>
  );
}
